import { useRuntimeConfig } from 'nuxt/app'
import { type DirectusFile } from '@directus/sdk'
import { computed } from 'vue'

// turns a directus image has into an url.
export const useImage = (
  id: string | DirectusFile | null | undefined,
  fileName: string | null | undefined,
  query: string | null | undefined
) => {
  // TODO: nice placeholder image
  if (!id) {
    return '#'
  }

  const config = useRuntimeConfig()

  return computed((): string => {
    // TODO: this needs testing, as it hasn't happened yet, but could.
    if (id && typeof id !== 'string') {
      id = id.id
    }

    let imageUrl = `${config.public.apiBaseUrl}/assets/${id}`

    if (fileName) {
      imageUrl += `/${fileName}`
    }

    // deal with params
    const params = new URLSearchParams(query || undefined)

    if (!params.get('quality')) {
      params.set('quality', '65')
    }
    if (!params.get('format')) {
      params.set('format', 'jpg')
    }
    if (!params.get('width')) {
      params.set('width', '500')
    }
    if (!params.get('height')) {
      params.set('height', '500')
    }

    // params.set('withoutEnlargement', 'true')

    const stringParams = params.toString()
    if (stringParams && stringParams !== '') {
      imageUrl += `?${stringParams}`
    }

    return imageUrl
  })
}
